import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsBannerComponent, CmsService } from '@spartacus/core';
import { CmsComponentData, GenericLinkComponent, MediaComponent } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'kn-br-banner',
    templateUrl: './kn-br-banner.component.html',
    styleUrls: ['./kn-br-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [GenericLinkComponent, MediaComponent, AsyncPipe]
})
export class KnBrBannerComponent implements OnInit {
  componentData$: Observable<CmsBannerComponent> = this.componentData.data$;
  readonly isNacPage$ = this.cmsService
    .getCurrentPage()
    .pipe(map((page) => page && page.template === 'NACPageTemplate'));

  constructor(private componentData: CmsComponentData<CmsBannerComponent>, protected cmsService: CmsService) {}

  ngOnInit(): void {}
}
